module.exports = __webpack_public_path__ + "images/caaae1eff6b52934e2c0453b54724949-Roboto-Medium.svg";